import SaveIcon from '@mui/icons-material/Save';
import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { TWorkflowState } from '../../data/WorkflowSteps';
import HelpBox from '../../utils/HelpBox';
import { useAppSelector } from './RunReduxHooks';
import { RunState } from './RunStore';
import { selectElaspedTimeHHMMSS, selectStatus } from './sliceRunProcHeader';

const HeaderStart = 'Traferox EVLP Wizard.'

export default function RunHeader({ workflowState, setCanPlayAudio }: { workflowState: TWorkflowState, setCanPlayAudio: (b: boolean) => void }) {
    switch (workflowState) {
        case 'setup': return (<RHSetup />)
        case 'rampup': return (<RHTimeline stateDescription='State: Ramp up.' setCanPlayAudio={setCanPlayAudio} />)
        case 'steady': return (<RHTimeline stateDescription='State: Steady state.' setCanPlayAudio={setCanPlayAudio} />)
        default: return null
    }
}

function RHSetup() {
    return (
        <Grid container spacing={1} sx={{ mb: '10px' }}>
            <Grid item xs={12}>
                <Typography variant='h5'>{`${HeaderStart} State: Setup.`}</Typography>
            </Grid>
            <Box sx={{ position: 'absolute', top: 0, right: 8 }}>
                <HelpBox showInsightVersion={false} />
            </Box>
        </Grid>)
}

function SavingProgress() {
    const status = useAppSelector(selectStatus)

    switch (status) {
        case 'idle':
            return null

        case 'loading':
            return (
                <>
                    <SaveIcon sx={{ opacity: .5 }} />
                    <CircularProgress size='small' />
                </>
            )

        case 'failed':
            return (
                <Typography
                    variant='body2'
                    sx={{
                        color: 'error.main',
                        fontWeight: 'bold',
                        border: '2px solid',
                        borderColor: 'error.main',
                        borderRadius: '4px',
                        px: 1,
                        ml: 1,
                        lineHeight: '28px',
                        mr:1
                    }}
                >
                    OFFLINE
                </Typography>
            )
    }
}

function RHTimeline({ stateDescription, setCanPlayAudio }: { stateDescription: string, setCanPlayAudio: (b: boolean) => void }) {
    const timeElasped = useAppSelector(selectElaspedTimeHHMMSS)
    const currentStepIndex = useSelector((state: RunState) => state.procHeaderSlice.data?.step)

    useLayoutEffect(() => {
        setCanPlayAudio(true)
    }, [currentStepIndex, setCanPlayAudio])

    return (
        <>
            <Grid container spacing={1} sx={{ mb: '10px' }}>
                <Grid item xs={11}>
                    <Typography variant='h5'>{`${HeaderStart} ${stateDescription}`}</Typography>
                </Grid>
                <Grid item xs={1} display="flex" justifyContent='flex-end' >
                    <Stack direction='row'>
                        <SavingProgress />
                        <Typography variant='h5'>{`${timeElasped.hh}:${timeElasped.mm}:${timeElasped.ss}`}</Typography>
                        <HelpBox showInsightVersion={false} />
                    </Stack>
                </Grid>
            </Grid>

        </>)
}


export function RHFinished() {
    const timeElasped = useAppSelector(selectElaspedTimeHHMMSS)

    return (
        <Grid container spacing={1} sx={{ mb: '10px' }}>
            <Grid item xs={11}>
                <Typography variant='h5'>{`${HeaderStart} Procedure finished`}</Typography>
            </Grid>
            <Grid item xs={1} display="flex" justifyContent='flex-end'>
                <Stack direction='row'>
                    <SavingProgress />
                    <Typography variant='h5'>{`${timeElasped.hh}:${timeElasped.mm}:${timeElasped.ss}`}</Typography>
                    <HelpBox showInsightVersion={false} />
                </Stack>
            </Grid>
        </Grid>
    )
}